import {fetch} from "utils/dataAccess";

export async function getShipmentById(id) {
    return new Promise(resolve => {
        fetch(`/shipments/${id}`, {}, false, true)
            .then(response => {
                    response.json().then(retrieved => {
                        resolve(retrieved)
                    })
                })
            .catch(error => reject(error))
    })
}